export { Puzzle as default } from './Puzzle';
